import {Component, DOCUMENT, Inject, OnInit, effect, OnDestroy, inject} from '@angular/core';
import {TenantService} from '../../../services/tenant.service';
import {Router, RouterLink} from '@angular/router';
import {LayoutService} from '../../../services/layout.service';
import {MenuItem, PrimeTemplate} from 'primeng/api';
import {CommonModule} from '@angular/common';
import {Button} from 'primeng/button';
import {Toolbar} from 'primeng/toolbar';
import {OverlayBadge} from 'primeng/overlaybadge';
import {Avatar} from 'primeng/avatar';
import {Menubar} from 'primeng/menubar';
import {Popover} from 'primeng/popover';
import {Drawer} from 'primeng/drawer';
import {MenuPartial} from '../menu/menu-partial';
import {AppGlobalEventManagerService} from '../../../services/app.globalEventManager.service';
import {AppSessionService} from '../../../services/app.session.service';
import {AppCacheService} from '../../../services/app.cache.service';
import {AppAuthService} from '../../../services/app.auth.service';
import {AppToasterService} from '../../../services/app.toaster.service';
import {
  AccessTokenInterface, IntraDoOperationApi,
  IntraEbChat,
  IntraEbHistory,
  IntraEbSinistreApi, IntraEbuzFactureApi,
  LoopBackAuth,
  PeopleApi
} from '../../../../shared/sdk';

import {OnlineService} from '../../../../modules/eBoarding/services/online.service';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {LogoPartial} from '../logo/logo-partial';
import {PeopleWithrightsInterface} from '../../../interfaces/peopleWithrights.interface';
import {ToAssetPipe} from '../../../pipes/toAsset.pipe';
import moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {ROLES} from '../../../datas/roles.helpers';
import {filesTypesIconByMime} from '../../../datas/fileType.helpers';
import {JplusBlocked, JplusWarning} from '../../../../modules/DOnet/models/JPlus';
import {colorsDeclarations} from '../../../../modules/eBoarding/models/consteBoarding';
import {interval} from 'rxjs';
import {map, takeWhile} from 'rxjs/operators';
import {FindPipe} from '../../../pipes/find.pipe';
import {Tooltip} from 'primeng/tooltip';
import {EventActionDirective} from '../../../../modules/eBoarding/directives/eventAction/eventAction.directive';
import {NgbActiveModal} from '../../../components/ngBootstrap/modal/modal-ref';
import {ModalCompatibilityService} from '../../../services/modal-compatibility.service';
import {AppExportDOService} from '../../../../modules/DOnet/services/app.export.service';
import type {
  PendingRappelAutoEntry,
  PendingRappelAutoResponse
} from '../../../../modules/Admin/pages/rappelAutoSinistres/rappelAutoSinistres.list.page';
import { ImgRszPipe } from '../../../pipes/imgRsz.pipe';
import { ImpersonationBannerPartial } from '../../partials/impersonationBanner/impersonationBanner.partial';

@Component({
  selector: 'app-header',
  imports: [RouterLink, CommonModule, Button, Toolbar, OverlayBadge, Avatar, Menubar, PrimeTemplate, Popover, Drawer, MenuPartial, LogoPartial, ToAssetPipe, ImgRszPipe, TranslocoPipe, FindPipe, Tooltip, EventActionDirective, ImpersonationBannerPartial],
  // CommonModule expose déjà AsyncPipe
  templateUrl: './header-partial.html',
  providers: []
})
export class HeaderPartial implements OnInit, OnDestroy {
  items!: MenuItem[];

  visible: boolean = false;
  menuExpanded = false;

  public user!: PeopleWithrightsInterface;
  public environment = environment;

  public ROLES = ROLES;

  public elem;
  public full:boolean = false;

  public btnrefrsh:boolean = false;

  public collapsedMenu:boolean = false; // Menu
  public counter: number;
  public totalTTL: number = 0;

  public sub;

  public declarationsDay = {declarations:{}};
  public nbDeclarationsDay = 0;

  // public facturesEcheanceAlertes = {factures:{}}; // Factures !!
  // public nbFacturesEcheanceAlertesDay = 0;
  public facturesFacturationAlertes!: {factures: any[]}; // Factures !!

  // Rappels auto qui doivent partir demain (admin uniquement)
  public rappelsTomorrowData: PendingRappelAutoResponse | null = null;
  public nbRappelsTomorrow: number = 0;

  public showOnline = false;
  public onlinesPeople: AccessTokenInterface[]= [];

  public showEvents = false;
  public events: IntraEbHistory[]= [];

  public lastChatMessages: IntraEbChat[] = [];

  public filesTypesIconByMime = filesTypesIconByMime;
  public blockedToJ: boolean = false;
  public nbJBlocked: number
  public nbJWarning: number

  // Rappels auto actifs pour ce tenant (false vgi/vgs : pas d'instance cron,
  // la cloche << rappels a envoyer demain >> serait un faux signal).
  public rappelsAutoActifs = inject(TenantService).feature('rappelsAuto');

  public allLanguages: {label:string, value:string, icon:string}[] = environment.allLanguages;
  public selectedLanguage = 'fr';

  constructor(
    public layoutService: LayoutService,
    private _appGlobalEventManagerService: AppGlobalEventManagerService,
    private _sessionService: AppSessionService,
    public _appCacheService: AppCacheService,
    public _peopleApi: PeopleApi,
    public router: Router,
    public _toastr : AppToasterService,
    private _authService: AppAuthService,
    private _onlineService: OnlineService,
    private translocoService: TranslocoService,

    public authService: LoopBackAuth,
    @Inject(DOCUMENT) public document: any,
    public _globalEventManager: AppGlobalEventManagerService,
    // private _eventService: EventService,
    // private _chatService: ChatService,
    private _ebSinistreApi: IntraEbSinistreApi,
    private _ebuizFactureApi: IntraEbuzFactureApi,
    private _ebOperationApiService: IntraDoOperationApi,
    public modalService: ModalCompatibilityService,
    private _appExportDOService: AppExportDOService,

  ) {
    // Synchroniser visible avec l'état du mobile menu
    effect(() => {
      this.visible = this.layoutService.isMobileMenuOpen();
    });
  }

  ngOnInit(): void {
    this.elem = document.documentElement;

    this.translocoService.langChanges$.subscribe((lang) => {
      this.selectedLanguage = lang;
    });

    this._sessionService.logguedAccountEmitter.subscribe((people) => {
      if(people){
        this.user = people;


        // DUPLICAT avec app.ts
        
        this._ebOperationApiService.hasDossierJ(JplusWarning, JplusBlocked).subscribe((res) => {
          if(res && res[JplusBlocked] && res[JplusBlocked].length > 0){

            let GoblockDateAG = true;
            if(this.user && this.user.dateNoLimitAG){
              GoblockDateAG = moment(this.user.dateNoLimitAG, 'YYYY-MM-DD').isBefore(moment())
            }

            this._globalEventManager._j30.next(GoblockDateAG); // Trigger Blocage J+30 + readonly sur dossiers != de la liste ! + Ne peut avoir que le volet de droite sur actualisation
            this._globalEventManager._listSinistresJ30.next(res[JplusBlocked]);
            this._globalEventManager._listSinistresJ27.next(res[JplusWarning]);
            this.nbJBlocked = res[JplusBlocked].length;
            this.nbJWarning = res[JplusWarning].length;
          } else {
            this._globalEventManager._j30.next(false);
            this._globalEventManager._listSinistresJ30.next([]);
            this._globalEventManager._listSinistresJ27.next([]);
          }
        })

        // Init menu !
        this.items = [
          {
            label: this.user?.fullname,
            items: [
              {
                label: this.translocoService.translate('Chats'),
                icon: 'pi pi-comment',
                routerLink: ['/profile']
              },
              {
                separator: true,
              },
              // {
              //   label: this.translocoService.translate('Profile'),
              //   icon: 'pi pi-user',
              //   routerLink: ['/profile']
              // },
              {
                label: this.translocoService.translate('Changer mon mot de passe'),
                icon: 'pi pi-shield',
                routerLink: ['/changePassword']
              },
              {
                separator: true,
              },
              {
                label: this.translocoService.translate('Renouveler la session'),
                icon: 'pi pi-refresh',
                command: () => {
                  this.makeCall()
                }
              },
              {
                label: this.translocoService.translate('Verrouiller la session'),
                icon: 'pi pi-lock',
                command: () => {
                  this.lock()
                }
              },
              {
                label: this.translocoService.translate('Logout'),
                icon: 'pi pi-sign-out',
                command: () => {
                  this.logout()
                }
              }
            ]
          }
        ];

        this.showOnline = this.showEvents = people && ROLES['admin'].indexOf(people.profil.name) !== -1;

        // Appeler callOnce directement ici si l'utilisateur est admin
        if(ROLES.admin.indexOf(people.profil.name) > -1){
          this.callOnce();

          // A REVOIR ! TODO

          if(this.user && this.user.accessEbuiz === 1){
            this._ebuizFactureApi.getRelancesFacturationsDay().subscribe((res) => {
              this.facturesFacturationAlertes = res;
            })
          }

        }
      } else {
        this.user = null;
        this.items = [];
        this.showOnline = false;
        this.showEvents = false;
      }
    });

    // Vérifier immédiatement la valeur actuelle
    const currentUser = this._sessionService.getLogguedAccount();
    if (currentUser) {
      // Déclencher manuellement la logique d'initialisation
      this.user = currentUser;
      this.showOnline = this.showEvents = currentUser && ROLES['admin'].indexOf(currentUser.profil.name) !== -1;

      if(ROLES.admin.indexOf(currentUser.profil.name) > -1){
        this.callOnce();
      }
    }


    this._onlineService._onlineEmitter.subscribe((result:AccessTokenInterface[]) => {
      if(this.showOnline === false){return}
      this.onlinesPeople = [...new Set(result)]; // delete duplicates
    });

    // this._chatService._lastChatsEmitter.subscribe((lastMessages: IntraEbChat[]) => {
    //   this.lastChatMessages = lastMessages;
    // });
    //
    // this._eventService._eventEmitter.subscribe((events:IntraEbHistory[]) => {
    //   if(this.showEvents === false){return}
    //   this.events = events;
    // });

    this._sessionService.TTLEmitter.subscribe((number) => {

      if(number && number > 0){
        this.totalTTL = number / 1000; // Convertir ms en secondes

        // Nettoyer l'ancien timer
        if(this.sub){
          this.sub.unsubscribe();
        }

        // Créer un nouveau timer qui décrémente chaque seconde
        let remainingTime = number; // Garder en millisecondes pour le calcul

        this._onlineService.timeLeftEmiter = interval(1000).pipe(
          map(() => {
            remainingTime -= 1000; // Décrémenter de 1000ms (1 seconde)
            return remainingTime;
          }),
          takeWhile(time => time > 0) // Arrêter quand le temps est écoulé
        );

        this.sub = this._onlineService.timeLeftEmiter.subscribe((timer) => {
          this.counter = timer / 1000; // Convertir en secondes pour l'affichage

          if(this.counter <= 1){
            this.modalService.dismissAll();
            this.lock();
            this.sub.unsubscribe();
          }
        });
      }
    });

    this._globalEventManager.menuCollapsedEmitter.subscribe((menuCollapsed : boolean) => {
      this.collapsedMenu = menuCollapsed;
    });

    this._globalEventManager.J30Emitter.subscribe((blocked: boolean) => {
      this.blockedToJ = blocked
    })

    // S'abonner aux compteurs J+30
    this._globalEventManager.nbJBlockedEmitter.subscribe((count: number) => {
      this.nbJBlocked = count;
    });

    this._globalEventManager.nbJWarningEmitter.subscribe((count: number) => {
      this.nbJWarning = count;
    });

  }

  changeLanguage(lang){



    this.translocoService.setActiveLang(lang);
  }

  public getColor(typedeclaration:string){

    let colors = colorsDeclarations;

    let color = null;
    switch (typedeclaration) {
      case 'out':{
        color = colors.red;
      }
        break;
      case '30':{
        color = colors.yellow;
      }
        break;
      case '60':{
        color = colors.green;
      }
        break;
      case '90':{
        color = colors.blue;
      }
        break;
      case '225':{
        color = colors.yellow;
      }
        break;
      case 'L114':{
        color = colors.red;
      }
        break;
      case 'preventExpert':{
        color = colors.purple;
      }
        break;
    }
    return color;
  }

  onMenuToggle(expanded: boolean) {
    this.menuExpanded = expanded;
  }

  logout(){
    if(this._authService.getAccessTokenId()){
      this._peopleApi.logout().subscribe(
        {
          next: (r) => {

          },
          error: (err) => {
            this._finishLogout('/login', 'Vous êtes correctement déconnecté.', 'Déconnexion');
          },
          complete: () => {
            this._finishLogout('/login', 'Vous êtes correctement déconnecté.', 'Déconnexion');
          }
        }
      );
    } else {
      this._finishLogout('/login', 'Vous êtes correctement déconnecté.', 'Déconnexion');
    }
  }

  lock(){
    this._peopleApi.logout().subscribe((r) => {
      this._finishLogout('/off/lock', 'Votre session a été verrouillée.', 'Verrouillage');
    });
  }

  /**
   * Nettoyage commun déconnexion / verrouillage : token, caches mémoire (AppCacheService),
   * fin d'une éventuelle impersonation + caches scope-sensibles persistés, session et flags J+30,
   * puis redirection. Important : sans ce nettoyage, le cache d'un admin (toutes les opérations)
   * ou l'état d'impersonation fuiteraient vers la session suivante (pas de rechargement de page au logout).
   */
  private _finishLogout(route: string, message: string, title: string){
    this._authService.clear();
    try { this._appCacheService.clearAllCaches(); } catch(e) {}
    localStorage.removeItem('$VGE$impersonation');
    localStorage.removeItem('sinistreTimer:context');
    localStorage.removeItem('sinistreTimer:visible');
    this._sessionService.updateLogguedAccount(null);
    this._onlineService.emitLogout(null);
    this._globalEventManager._j30.next(false);
    this._globalEventManager._listSinistresJ30.next([]);
    this._globalEventManager._listSinistresJ27.next([]);
    this._toastr.success(message, title);
    this.router.navigate([route]);
  }

  /**
   * Update TTL !
   */
  makeCall(){
    this._peopleApi.me().subscribe();
  }

  toggleDarkMode() {
    this.layoutService.toggleDarkMode();
  }

  callOnce(){
    // Rappels auto « demain » : compteur DATÉ → doit être rafraîchi à CHAQUE
    // émission du compte (login / renouvellement de session / déverrouillage),
    // comme hasDossierJ juste au-dessus. Gardé par _loadOnce, il se figeait à la
    // 1ʳᵉ valeur de la session (souvent 0) alors que la page
    // Admin/rappels-auto-sinistres, elle, recharge le même endpoint à chaque
    // visite → d'où la divergence du badge cloche.
    this.refreshRappelsTomorrow();

    if(this._sessionService._loadOnce.getValue() === false){ // var pour savoir si on a fait 1 call

      // this._peopleApi.me()

      this._ebSinistreApi.getDeclarationsDay(false).subscribe((res) => {
        Object.keys(res.declarations).forEach((k) => {
          this.nbDeclarationsDay += res.declarations[k].length;
        });
        this.declarationsDay = res;
      })

      this._sessionService._loadOnce.next(true);
    }
  }

  /**
   * Recharge le compteur « rappels auto à envoyer demain » (badge cloche admin).
   * Appelé à chaque émission du compte ET à l'ouverture du popover, pour ne
   * jamais afficher une valeur figée/périmée (la valeur est relative à « demain »).
   */
  refreshRappelsTomorrow(){
    this._appExportDOService.fetchPendingRappelAuto('tomorrow').subscribe((res: PendingRappelAutoResponse) => {
      this.rappelsTomorrowData = res;
      this.nbRappelsTomorrow = res?.count || 0;
    });
  }

  /** Aplati les entries pour le popover (preview des 1ères entrées tous clients confondus). */
  get rappelsTomorrowEntries(): PendingRappelAutoEntry[] {
    if(!this.rappelsTomorrowData?.clients){ return []; }
    const out: PendingRappelAutoEntry[] = [];
    for(const c of this.rappelsTomorrowData.clients){
      out.push(...(c.sinistresOwn || []));
      for(const f of (c.fonds || [])){
        out.push(...(f.sinistres || []));
      }
    }
    return out;
  }

  openSlideJ(){
    this._appGlobalEventManagerService.updateColumnJPlus(true);
  }

  ngOnDestroy(): void {
    if(this.sub){
      this.sub.unsubscribe();
    }
  }

  protected readonly JplusBlocked = JplusBlocked;
  protected readonly moment = moment;
}

